/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCell,
} from '../../../../../../components/UI'
import React, {FC, useEffect, useMemo, useState} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../../models'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {
  createCheckinService,
  createCheckinServiceList,
  createPreCheckinService,
  getCheckingService,
} from '../../../../services/checking.service'
import {CheckingModel} from '../../../../models/ckecking.model'
import {ModalSearchHuesped} from '../Modal/ModalSearchHuesped'
import ActionsContent from '../../../../pages/components/Actions'
import Swal from 'sweetalert2'
import {
  downloadPDFCheckInOutService,
  downloadPDFPreCheckInListService,
} from '../../../../services/booking.service'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {CampModel, ClientModel, CompanyModel, SiteModel} from '../../../../../central/model'
import {getCamp, getClient, getCompany, getSite} from '../../../../../central/services'
import {getMasterModuleService} from '../../../modules/services'
import {paginationGuestsService} from '../../../guests/services'
import {FormMasiveUploadCheckIn} from '../Forms/FormMasiveUploadCheckin'
import {getGuestByIdService} from '../../../../services/guest.service'
import {ModalTyC} from '../Modal/ModalTyC'
import {getSnackBar, getSnackBarToast} from '../../../../../../util/snackBar'
import {getTermsService} from '../../../tyc/services'
import ActionsCheckinContent from '../../../../pages/components/ActionsCheckin'
interface SelectOption {
  value: string | number | undefined
  label: string | undefined
}

const TableChecking: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    clearSelected,
    updateTable,
    setUpdateTable,
    clearTable,
    setClearTable,
    selected,
  } = useKTable()
  const {changeCurrentTabItem, currentTabItem, showModalSearch, setShowModalSearch, isAllowed} =
    useHoteleria()
  const {selectedOn} = useKTable()
  const {changeSearchValues, searchValues, clearSearchValues} = useKhipu()
  const [compani, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [site, setSite] = useState<SelectOption[]>([])
  const [camp, setCamp] = useState<SelectOption[]>([])
  const [bedTypes, setBedTypes] = useState<SelectOption[]>([])
  const [statusPreChecking, setStatusPreChecking] = useState<SelectOption[]>([
    {value: 'true', label: 'SI'},
    {value: 'false', label: 'NO'},
  ])
  const [companyType, setCompanyType] = useState<SelectOption[]>([])
  const [guestTypes, setGuestTypes] = useState<SelectOption[]>([])
  const [statusType, setStatusType] = useState<SelectOption[]>([])
  const [guest, setGuest] = useState<SelectOption[]>([])
  const [selectedItem, setSelectedItem] = useState<any>(null)
  const [showModalTyC, setShowModalTyC] = useState(false)
  const [guestInfo, setGuestInfo] = useState<any>(null)
  const [tycInfo, setTyCInfo] = useState<any>(null)

  ///

  const getCompanyList = async () => {
    let obj: CompanyModel = {
      isCombo: true,
    }
    const response = await getCompany(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({
      value: item.id,
      label: item.nombreEmpresa,
    }))
    setCompany(mappedSites)
  }

  const getClientList = async () => {
    let obj: ClientModel = {
      isCombo: true,
    }
    const response = await getClient(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setClient(mappedSites)
  }

  const getSiteList = async () => {
    let obj: SiteModel = {
      isCombo: true,
    }
    const response = await getSite(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setSite(mappedSites)
  }
  const getCampList = async () => {
    let obj: CampModel = {
      isCombo: true,
    }
    const response = await getCamp(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setCamp(mappedSites)
  }

  const getBedTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoCama',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setBedTypes(mappedMaster)
    } catch (error) {
      setBedTypes([])
    }
  }

  const getCompanyTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoEmpresa',
      })
      const data = response.data.data
      const mappedModuleTypes = data?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      setCompanyType(mappedModuleTypes)
    } catch (error) {
      setCompanyType([])
    }
  }

  const getStatusTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        names: 'Asignada',
        tableName: 'EstadoReservaHuesped', // EstadoReservaCamaHuesped
      })
      const data = response.data.data
      const mappedModuleTypes = data?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      setStatusType(mappedModuleTypes)
    } catch (error) {
      setStatusType([])
    }
  }

  const getGuestTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoHuesped',
      })
      const data = response.data.data
      const mappedModuleTypes = data?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      setGuestTypes(mappedModuleTypes)
    } catch (error) {
      setGuestTypes([])
    }
  }

  const getGuests = async (siteId: string) => {
    try {
      const {data: response} = await paginationGuestsService({
        pageNumber: 1,
        size: 2000,
        SiteId: siteId,
      })
      if (!response.error) {
        const mappedGuests = response.data?.map((guest) => ({
          value: guest.Id,
          label: `${guest.Nombres} ${guest.ApellidoPaterno} ${guest.ApellidoMaterno}`,
        }))
        setGuest(mappedGuests)
      }
    } catch (error) {
      setGuest([])
    }
  }

  ///

  const getChekings = async (dataFilter: any = null) => {
    var request = {
      pageNumber: pagination.currentPage,
      size: pagination.perPage,
      StatusCode: '2,8', // ASIGNADO - PRECHECKING
      ...dataFilter,
      ...searchValues,
    }
    console.log('dataFilter', dataFilter)
    console.log('searchValues', searchValues)
    if ((searchValues?.EsPreCheckIn ?? '').length > 0) {
      if (searchValues?.EsPreCheckIn === 'true') request.EsPreCheckIn = true
      if (searchValues?.EsPreCheckIn === 'false') request.EsPreCheckIn = false
    }
    console.log('request', request)
    setShowModalSearch(false)
    try {
      setLoading(true)
      // changeSearchValues({})
      const {data: response} = await getCheckingService(request)
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
        // if (response.data.length === 0 && data){
        //   Swal.fire(
        //       'Ups!',
        //       'Parece que el huésped no tiene una reserva asignada!',
        //       'warning'
        //   )
        // }
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  // const getHuesped = (data:any) => {
  //   getChekings();
  // }

  const loadOptions = async (inputValue: string) => {
    try {
      if (inputValue.length < 3) {
        return []
      }
      const {data: response} = await paginationGuestsService({
        pageNumber: 1,
        size: 500,
        BuscaTexto: inputValue,
      })
      if (!response.error) {
        const mappedGuests = response.data?.map((guest) => ({
          value: guest.Id,
          label: `${guest.Nombres} ${guest.ApellidoPaterno} ${guest.ApellidoMaterno} ${guest.NumeroDocumento}`,
          ...guest,
        }))
        return mappedGuests
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }

  const handleGetId = (item: any) => {
    setSelectedItem(item)
    let idChange = item.ReservaCamaId === currentTabItem.idToDelete ? '' : item.ReservaCamaId
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const handleFilterCamp = (e: any, name: string) => {
    let value = e.value
    getGuests(value)
  }

  useEffect(() => {
    if (Object.keys(searchValues).length === 0) {
      getChekings()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValues])

  useEffect(() => {
    getChekings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
    }
    changeCurrentTabItem(obj)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const columns: Column<CheckingModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} showSelect={true} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCell id={props.data[props.row.index].ReservaCamaId} />
        ),
        // Cell: ({...props}) => (
        //   <KTableSelectionCellNonMultiple
        //     id={props.data[props.row.index].ReservaCamaId}
        //     clickHandler={() => handleGetId(props.data[props.row.index])}
        //   />
        // ),
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Etiqueta' name='Etiqueta' searcheable />
        ),
        accessor: 'Etiqueta',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Pre-Checkin'
            name='EsPreCheckIn'
            selecteable
            data={statusPreChecking}
          />
        ),
        id: 'pre',
        Cell: ({...props}) => <>{props.data[props.row.index].EsPreCheckIn ? 'SI' : 'NO'}</>,
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Módulo'
            name='CodigoModulo'
            searcheable
          />
        ),
        accessor: 'Modulo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Habitación'
            name='CodigoHabitacion'
            searcheable
          />
        ),
        accessor: 'Habitacion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Cama'
            name='CodigoCama'
            searcheable
          />
        ),
        accessor: 'CodigoCama',
      },
      // {
      //   Header: (props) => (
      //     <KTableHeader
      //       tableProps={props}
      //       title='Tipo de cama'
      //       name='TipoCamaId'
      //       selecteable
      //       data={bedTypes}
      //     />
      //   ),
      //   accessor: 'CamaTipo',
      // },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nro Documento' name='NroDocumento' searcheable />
        ),
        accessor: 'NroDoc',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Huésped'
            name='HuespedId'
            selectLabel='HuespedLabel'
            selecteableAsync
            loadOptions={loadOptions}
            placeholder='Busca un Huésped...'
          />
        ),
        accessor: 'HuespedDescripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Empresa Subcontratista'
            name='EmpresaContratista'
            searcheable
          />
        ),
        accessor: 'RazonSocialSubContratista',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Inicio' name='FechaIni' dateable />
        ),
        accessor: 'FechaInicio',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Fin' name='FechaFin' dateable />
        ),
        accessor: 'FechaFin',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado de Reserva - Huésped'
            name='EstadoReservaId'
            selecteable
            data={statusType}
          />
        ),
        accessor: 'Estado',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estatus Huésped'
            name='TipoHuespedId'
            selecteable
            data={guestTypes}
          />
        ),
        accessor: 'TipoHuespedNombre',
      },
      // {
      //   Header: (props) => (
      //     <KTableHeader
      //       tableProps={props}
      //       title='Compañía'
      //       name='CompaniaId'
      //       selecteable
      //       data={compani}
      //     />
      //   ),
      //   accessor: 'Compania',
      // },
      // {
      //   Header: (props) => (
      //     <KTableHeader
      //       tableProps={props}
      //       title='Cliente'
      //       name={'ClienteId'}
      //       selecteable
      //       data={client}
      //     />
      //   ),
      //   accessor: 'Cliente',
      // },
      // {
      //   Header: (props) => (
      //     <KTableHeader
      //       tableProps={props}
      //       title='Site'
      //       name={'SiteId'}
      //       selecteable
      //       data={site}
      //       onGetValueSelect={handleFilterCamp}
      //     />
      //   ),
      //   accessor: 'Site',
      // },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Campamento'
            name='CampamentoId'
            selecteable
            data={camp}
          />
        ),
        accessor: 'Campamento',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='N° Reserva'
            name='NroReserva'
            searcheable
            number
          />
        ),
        accessor: 'CodigoReserva',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Productos' />,
        id: 'actions',
        Cell: ({...props}) =>
          isAllowed('VER') ? (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() =>
                showProducts(props.row.original.ReservaCamaId, props.row.original.ImpresionCheckIn)
              }
            >
              <a
                href='#'
                className='btn btn-icon btn-link btn-color-gray-500 btn-active-color-success btn-sm'
              >
                <KTSVG path='/media/icons/duotune/general/gen004.svg' className='svg-icon-2' />
              </a>
            </div>
          ) : (
            <></>
          ),
      },
    ],
    [compani, client, site, camp, bedTypes, guest, statusType, guestTypes, selectedOn],
  )

  useEffect(() => {
    getCompanyList()
    getClientList()
    getSiteList()
    getCampList()
    getBedTypes()
    getCompanyTypes()
    getStatusTypes()
    getGuestTypes()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (updateTable) {
      clearSelected()
      if (pagination.currentPage === 1) {
        getChekings()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  useEffect(() => {
    if (clearTable) {
      if (pagination.currentPage === 1) {
        getChekings()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  useEffect(() => {
    if (currentTabItem.deleted) {
      clearSelected()
      getChekings()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.deleted])

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const showProducts = (ReservaCamaId: string, ImpresionCheckIn: number | undefined | null) => {
    if (ReservaCamaId) {
      const obj: TabModel = {
        ...currentTabItem,
        showPanel: true,
        content: {
          ...currentTabItem.content,
          detailPanel: 'table-checkin-table',
        },
        idToDelete: '',
        idToEdit: ReservaCamaId,
        objectInfo: {
          ImpresionCheckIn: ImpresionCheckIn,
        },
      }
      changeCurrentTabItem(obj)
      clearSelected()
    }
  }

  const handleSearch = () => {
    setShowModalSearch(true)
  }

  const printPdf = (pdfUrl: any) => {
    const printWindow = window.open(pdfUrl, '_blank')
    if (printWindow) {
      printWindow.addEventListener('load', () => {
        printWindow.focus()
        printWindow.print()
      })
    }
  }

  const handleAskAddProducts = async (item: any) => {
    console.log(item)
    let dto = {
      reservaCamaId: item.ReservaCamaId,
      tipo: 'IN',
      MotivoReimpresionId: '',
      Otros: '',
    }
    const response = await downloadPDFCheckInOutService(dto)
    const blob = new Blob([response.data], {type: 'application/pdf'})
    let url = window.URL.createObjectURL(blob)
    setTimeout(() => {
      printPdf(url)
    }, 1000)
    Swal.fire({
      title: 'Se ha realizado el check-in',
      html: `<div id="print_pdf">
              <button
                id='printButton'
                class='sdx_btn m-auto'
                type='button'
              >Imprimir Ticket CheckIn</button>
            </div>
      <br> ¿Deseas agregar productos al huesped?`,
      //showDenyButton: true,
      icon: 'success',
      showCancelButton: true,
      confirmButtonText: 'Si, agregar productos',
      //confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      didOpen: () => {
        const printButton = document.getElementById('printButton') as HTMLElement
        printButton.addEventListener('click', () => printPdf(url))
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        Swal.close()
        showProducts(item?.ReservaCamaId, item.ImpresionCheckIn)
        Swal.close()
      } else if (result.isDenied) {
        Swal.close()
      }
    })
  }

  const getTyC = async (siteId: string, resultado: any) => {
    try {
      const {data: response} = await getTermsService({pageNumber: 1, size: 100, SiteId: siteId})
      if (!response.error) {
        if (response.data.length !== 0 && response.data[0].ModRecepcion) {
          await setTyCInfo(response.data[0])
          await setShowModalTyC(true)
        } else {
          if (resultado !== null) {
            const confirmed = await showSwalConfirm()
            if (confirmed) {
              return true // Swal.close()
            } else {
              return false // Swal.close() // console.log('Usuario canceló', resultado)
            }
          } else {
            Swal.fire('', 'Debes seleccionar por lo menos una reserva', 'warning')
          }
        }
      }
    } catch (error) {}
    return false
  }

  const handleCreateCheckIn = async () => {
    try {
      setLoading(true)
      const {data: response} = await createCheckinService({
        ReservaId: selectedItem.ReservaId,
        CamaId: selectedItem.CamaId,
        HuespedId: selectedItem.HuespedId,
      })
      if (response.error) {
        getSnackBarToast(response.message, 'error')
        setLoading(false)
        return
      }
      handleAskAddProducts(selectedItem)
      const obj: TabModel = {
        ...currentTabItem,
        showPanel: false,
        idToDelete: '',
        idToEdit: '',
      }
      changeCurrentTabItem(obj)
      setTimeout(function () {
        getChekings()
      }, 1000)
    } catch (error) {}
  }

  const showSwalConfirm = (): Promise<boolean> => {
    return new Promise((resolve) => {
      Swal.fire({
        title: '¿Estás seguro?',
        html: 'No podrás revertir esta acción',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, Check In',
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        resolve(result.isConfirmed)
      })
    })
  }

  const updateClick = async (pre: boolean = false) => {
    const selectedSet = new Set(selected)
    const resultado = data.filter((item) => selectedSet.has(item.ReservaCamaId))
    // const request: Array<{ ReservaId: string; CamaId: string; HuespedId: string }> = []

    const request = resultado.map((r) => {
      return {
        ReservaId: r.ReservaId,
        CamaId: r.CamaId,
        HuespedId: r.HuespedId,
        ReservaCamaId: r.ReservaCamaId,
      }
    })
    console.log(pre)
    if (request.length > 0) {
      const confirmed = await showSwalConfirm()
      if (confirmed) {
        Swal.close()
        setLoading(true)
        if (pre) {
          const {data: response} = await createPreCheckinService({reservas: request})
          if (response.error) {
            getSnackBarToast(response.message, 'error')
            setLoading(false)
            return
          } else {
            getSnackBarToast('Se ha realizado el pre check-in', 'success')
            try {
              const responsePDF = await downloadPDFPreCheckInListService({
                reservasId: resultado.map((r) => r.ReservaCamaId),
              })
              const blob = new Blob([responsePDF.data], {type: 'application/pdf'})
              let url = window.URL.createObjectURL(blob)
              setTimeout(() => {
                printPdf(url)
              }, 1000)
              Swal.fire({
                title: 'Se ha realizado el pre check-in',
                icon: 'success',
                confirmButtonText: 'Ok',
                showLoaderOnConfirm: true,
                allowOutsideClick: () => !Swal.isLoading(),
              }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  Swal.close()
                } else if (result.isDenied) {
                  Swal.close()
                }
              })
            } catch (error) {
              Swal.fire('', 'No se pudo descargar los tickets', 'warning')
            } finally {
              setLoading(false)
              getChekings()
            }
          }
        } else {
          const {data: response} = await createCheckinServiceList({reservas: request})
          if (response.error) {
            getSnackBarToast(response.message, 'error')
            setLoading(false)
            return
          }
          if (request.length === 1) {
            setSelectedItem(request[0])
            console.log(request[0])
            handleAskAddProducts(request[0])
            const obj: TabModel = {
              ...currentTabItem,
              showPanel: false,
              idToDelete: '',
              idToEdit: '',
            }
            changeCurrentTabItem(obj)
            setTimeout(function () {
              getChekings()
            }, 1000)
          }
          setLoading(false)
          getChekings()
        }
      }
    } else {
      Swal.fire('', 'No hay reservas válidas seleccionadas', 'warning')
    }
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <ActionsCheckinContent
          filterClick={handleSearch}
          updateClick={updateClick}
          loading={loading}
          textComponentBack='table-checkin'
          textComponentGo='form-checking'
          seleccionados={selected.length}
        />
        {loading ? <KTableLoading title='Cargando...' /> : null}
        {isAllowed('LISTAR') && <KTable data={data} columns={columns} clearFilters />}
        {showModalSearch ? (
          <ModalSearchHuesped
            show={showModalSearch}
            setShow={setShowModalSearch}
            getChekings={getChekings}
            isCheckin
          />
        ) : (
          <></>
        )}
        {showModalTyC ? (
          <ModalTyC
            show={showModalTyC}
            setShow={setShowModalTyC}
            getChekings={getChekings}
            guestInfo={guestInfo}
            tycInfo={tycInfo}
            handleCreateCheckIn={handleCreateCheckIn}
          />
        ) : (
          <></>
        )}
      </KTCard>
    </>
  )
}

const TableCheckingWrapper = () => {
  const {isAllowed} = useHoteleria()
  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Check In</Tab>
            {isAllowed('MASIVO') && <Tab className={'sdx_sub_tab_panel_option'}>Carga Masiva</Tab>}
          </TabList>
          <TabPanel>
            <TableChecking />
          </TabPanel>
          {isAllowed('MASIVO') && (
            <TabPanel>
              <FormMasiveUploadCheckIn />
            </TabPanel>
          )}
        </Tabs>
      </div>
    </KTableProvider>
  )
}

export {TableCheckingWrapper}
